<!--===========================
=            INBOX            =
============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Email Inbox</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" sm="12">
        <base-card>
          <div slot="card-header">

             <v-list  class="transparent">

            <v-list-item class="transparent" link>
              <v-list-item-avatar size="50" class="rounded-lg" outlined>
                <v-img src="../../assets/images/2.png"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h6 white--text">
                  John Leider
                </v-list-item-title>
                <v-list-item-subtitle class="">Web Design</v-list-item-subtitle>
              </v-list-item-content>


            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list  class="transparent white--text" dark>
            <v-list-item v-for="[icon, text] in links" :key="icon" link>
              <v-list-item-icon>
                <v-icon>{{ icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
          <v-list-item dark v-for="file in files" :key="file.title">

            <v-icon class="mr-2 white--text" v-text="file.icon"></v-icon>
            <v-list-item-content>
              <v-list-item-title dark v-text="file.title"></v-list-item-title>


            </v-list-item-content>

            <v-list-item-action>
              <v-btn class="white--text" outlined text>
                {{file.number}}
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dark v-for="folder in folders2" :key="folder.title">

            <v-icon class="mr-2 " :color="folder.color">
              toll
            </v-icon>
            <v-list-item-content>
              <v-list-item-title v-text="folder.title"></v-list-item-title>


            </v-list-item-content>


          </v-list-item>

          </v-list>
          </div>
          <div slot="card-body">
        
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="9" sm="12">
        <base-card>
          <div slot="card-header">

              <v-list height="82" class="transparent">

            <v-list-item   class="transparent" link>
              <v-btn-toggle v-model="toggle_none"  class="transparent">
                <v-btn class="transparent">
                  <v-icon class="white--text">approval</v-icon>
                </v-btn>

                <v-btn class="transparent">
                  <v-icon class="white--text">folder_copy</v-icon>
                </v-btn>
                <v-btn class="transparent">
                  <v-icon class="white--text">attach_email</v-icon>
                </v-btn>

                <v-btn class="transparent">
                  <v-icon class="white--text">badge</v-icon>
                </v-btn>
                <v-btn class="transparent">
                  <v-icon class="white--text">local_offer</v-icon>
                </v-btn>

                <v-btn class="transparent">
                  <v-icon class="white--text">restore_from_trash</v-icon>
                </v-btn>
                <v-btn class="transparent">
                  <v-icon class="white--text">hotel_class</v-icon>
                </v-btn>

                <v-btn class="transparent">
                  <v-icon class="white--text">all_inbox</v-icon>
                </v-btn>
                <v-btn class="transparent">
                  <v-icon class="white--text">add_to_drive</v-icon>
                </v-btn>  <v-btn class="transparent">
                  <v-icon class="white--text">local_offer</v-icon>
                </v-btn>

                <v-btn class="transparent">
                  <v-icon class="white--text">restore_from_trash</v-icon>
                </v-btn>
                <v-btn class="transparent">
                  <v-icon class="white--text">hotel_class</v-icon>
                </v-btn>

                <v-btn class="transparent">
                  <v-icon class="white--text">all_inbox</v-icon>
                </v-btn>
                <v-btn class="transparent">
                  <v-icon class="white--text">add_to_drive</v-icon>
                </v-btn>
              </v-btn-toggle>


            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          </div>
          <div slot="card-body">
             <v-subheader>Today</v-subheader>

          <v-list dark  class=" transparent rounded-lg" outlined two-line>
            <v-list-item-group v-model="selected" active-class="pink--text" multiple>
              <template v-for="(item, index) in items">
                <v-list-item :key="item.title">
                  <template v-slot:default="{ active }">
                    <v-checkbox :input-value="active"></v-checkbox>
                    <v-icon v-if="!active" color="grey lighten-1">
                      mdi-star-outline
                    </v-icon>

                    <v-icon v-else color="yellow darken-3">
                      mdi-star
                    </v-icon>

                    <v-list-item-content class="pl-3">


                      <v-list-item-title v-text="item.title"></v-list-item-title>

                      <v-list-item-subtitle class="text--primary" v-text="item.headline">
                      </v-list-item-subtitle>

                      <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-action-text v-text="item.action"></v-list-item-action-text>

                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
          </div>
        </base-card>
      </v-col>
    

    </v-row>


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data: () => ({
      toggle_none: null,
      cards: ['Today', 'Yesterday'],
      drawer: null,
      name: '',
      files: [{
          number: '23',
          color: 'red',
          icon: 'favorite_border',
          subtitle: 'Jan 20, 2014',
          title: 'Holiday',
        },
        {
          number: 14,
          color: 'amber',
          icon: 'grade',
          subtitle: 'Jan 20, 2014',
          title: 'Follows',
        },
        {
          number: 24,
          color: 'primary',
          icon: 'pending_actions',
          subtitle: 'Jan 10, 2014',
          title: 'Spam',
        },
        {
          number: 12,
          color: 'red',
          icon: 'announcement',
          subtitle: 'Jan 20, 2014',
          title: 'Remove All',
        },
        {
          number: 34,
          color: 'purple',
          icon: 'mdi-gesture-tap-button',
          subtitle: 'Jan 10, 2014',
          title: 'Files Arquive',
        },
      ],
      links: [
        ['mdi-inbox-arrow-down', 'Inbox'],
        ['mdi-send', 'Send'],
        ['mdi-delete', 'Trash'],
        ['mdi-alert-octagon', 'Spam'],
      ],
      folders2: [{
          color: 'secondary',
          subtitle: 'Jan 9, 2014',
          title: 'Important',
        },
        {
          color: 'primary',
          subtitle: 'Jan 17, 2014',
          title: 'Favorite',
        },
        {
          color: 'accent',
          subtitle: 'Jan 28, 2014',
          title: 'Delete',
        },
      ],
      selected: [2],
      items: [{
          action: '15 min',
          headline: 'Brunch this weekend?',
          subtitle: `I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
          title: 'Ali Connors',
        },

        {
          action: '12 hr',
          headline: 'Birthday gift',
          subtitle: 'Have any ideas about what we should get Heidi for her birthday?',
          title: 'Trevor Hansen',
        },
        {
          action: '18hr',
          headline: 'Recipe to try',
          subtitle: 'We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          title: 'Britta Holt',
        }, {
          action: '19hr',
          headline: 'Recipe to try',
          subtitle: 'We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          title: 'Template Envato',
        },
        {
          action: '15 min',
          headline: 'Brunch this weekend?',
          subtitle: `I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
          title: 'Alex Connors',
        },
        {
          action: '2 hr',
          headline: 'Summer BBQ',
          subtitle: `Wish I could come, but I'm out of town this weekend.`,
          title: "Jennifer",
        },
        {
          action: '6 hr',
          headline: 'Oui oui',
          subtitle: 'Do you have Paris recommendations? Have you ever been?',
          title: 'Smira Adams',
        },
        {
          action: '12 hr',
          headline: 'Birthday gift',
          subtitle: 'Have any ideas about what we should get Heidi for her birthday?',
          title: 'Trek Trek',
        },


      ],
      selected3: ['Trevor Handsen'],
      items2: ['Trevor Handsen', 'Alex Nelson'],
      title: 'Hi,\nI just wanted to check in and see if you had any plans the upcoming weekend. We are thinking of heading up to Napa',
    }),
    methods: {
      scrolling(evt) {
        console.log(evt);
      },
      godashboard1() {
        return this.$router.push("/dashboard/dashboard1");
      },

    }

  }
</script>


<!--====  End of INBOX  ====-->
